import React from "react";

import { ModalWrapper } from "../../../../components/ModalWrapper/ModalWrapper";
import type { OrderDetailV2ActionModalProps } from "../../types";
import { InfoModalContent } from "../InfoModalContent/InfoModalContent";

import { ActionModalBody } from "./OrderDetailV2ActionModal.style";

export const OrderDetailV2ActionModal: React.FC<
  OrderDetailV2ActionModalProps
> = ({ config, onClose }) => {
  if (!config) return null;
  return (
    <ModalWrapper
      isOpen={Boolean(config)}
      onClose={onClose}
      customWidth="420px"
    >
      <ActionModalBody>
        <InfoModalContent
          viewType={config.viewType}
          data={config.componentData}
        />
      </ActionModalBody>
    </ModalWrapper>
  );
};

export default OrderDetailV2ActionModal;
